// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"35900c9a","518":"9527dc04","628":"95a2191f"}[chunkId] + ".chunk.css";
};